import React, { useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import Page from "../../finwell/pages/Page";
import "./CoachingRequestForm.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  coachingRequestSubmit,
  getAllSkills,
  getAllSkillsClear,
  registerCoach,
} from "../../redux/coaching/actions";
import { SessionKeys } from "../../utils/AppUtils";
import { useEffect } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Select from "react-select";
import ConfirmModal from "../../components/modal/ConfirmModal";

const RegisterCoachForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [skillsList, setSkillsList] = useState([]);
  const [skillsSet, setSkillsSet] = useState([]);
  const [interestsList, setInterestsList] = useState([]);
  const [interestSet, setInterestSet] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedIntrest, setselectedIntrest] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [experience, setExperience] = useState([
    { id: "1", value: "No Experience" },
    { id: "2", value: "Less than 1 year" },
    { id: "3", value: "1-2 years" },
    { id: "4", value: "3-5 years" },
    { id: "5", value: "6-10 years" },
    { id: "6", value: "More than 10 years" },
  ]);
  const [selectedExperience, setSelectedExperience] = useState("");
  const [linkedInURL, setLinkedInURL] = useState("");
  const [twitterURL, setTwitterURL] = useState("");
  const [dsgn, setDsgn] = useState("");
  const [price, setPrice] = useState();
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const coachingStore = useSelector((state) => state.coaching.skillsList);
  const [apiCalled, setApiCalled] = useState(false);

  const registerCoachResponse = useSelector(
    (state) => state.coaching.registerCoachData
  );

  useEffect(() => {
    if (!_.isEmpty(registerCoachResponse) && apiCalled) {
      if (registerCoachResponse?.status === "success") {
        setShowModalMsg("Successfully registered as a coach!");
        setConfirmModal(true);
        setIsLoading(false);
      } else {
        setShowModalMsg("Failed to registered as a coach!");
        setConfirmModal(true);
        setIsLoading(false);
      }
    }
  }, [registerCoachResponse]);

  useEffect(() => {
    console.log("coachingStore", coachingStore);
    if (!_.isEmpty(coachingStore)) {
      if (coachingStore?.status === "success") {
        let InterestsList = coachingStore?.payload?.payload?.interest;
        setInterestSet(InterestsList);
        setInterestsList(
          _.map(InterestsList, (interest) => {
            return {
              value: interest?.id,
              label: interest?.name,
            };
          })
        );

        let list = coachingStore?.payload?.payload?.skill;
        setSkillsSet(list);
        setSkillsList(
          _.map(list, (skill) => {
            return {
              value: skill?.id,
              label: skill?.name,
            };
          })
        );
        setIsLoading(false);
      } else {
        setSkillsList([]);
        setIsLoading(false);
      }
    }
  }, [coachingStore]);

  const getAllSkillsAPI = () => {
    setIsLoading(true);
    dispatch(
      getAllSkills({
        module: "getAllSkills",
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
      })
    );
  };

  useEffect(() => {
    getAllSkillsAPI();
    return () => {
      dispatch(getAllSkillsClear());
    };
  }, [dispatch]);

  const validateFields = () => {
    let isValid = true;

    if (selectedSkills?.length === 0) {
      isValid = false;

      setErrorMsg("Please select atleast one skill");
      setTimeout(() => {
        setErrorMsg("");
      }, 5000);
    }
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }
    setIsLoading(true);
    const data = {
      module: "registerCoach",
      postData: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        skill: selectedSkills?.map((item) => _.toInteger(item?.id)),
        interest: selectedIntrest?.map((item) => _.toInteger(item?.id)),
        experience: selectedExperience,
        price: price,
        dsgn: dsgn,
        linkdin: linkedInURL,
        twitter: twitterURL,
      },
    };
    setApiCalled(true);
    dispatch(registerCoach(data));
  };
  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <section className="coaching-form">
          <div className="container mt-4">
            <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
              >
                <path
                  d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                  fill="black"
                />
              </svg>{" "}
              Back
            </button>
            <h3 className="mentor-title mb-0">Register as a coach</h3>

            <Form className="sills-form mt-4">
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group
                    className="frm-box align-items-start"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent Enter key from submitting the form
                      }
                    }}
                  >
                    <Form.Label>Skills *</Form.Label>
                    <Select
                      isMulti
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      placeholder="Select skills"
                      options={skillsList}
                      value={selectedSkills.map((skill) => ({
                        value: skill.id,
                        label: skill.name,
                      }))}
                      isLoading={isLoading}
                      onChange={(e) => {
                        console.log(e);
                        if (!_.isEmpty(e)) {
                          let data = [];
                          console.log("check---", e);
                          for (let skill of skillsSet) {
                            for (let sO of e) {
                              if (
                                _.toNumber(sO.value) === _.toNumber(skill.id)
                              ) {
                                data.push(skill);
                              }
                            }
                          }
                          console.log("set data", data);
                          setSelectedSkills(data);
                        } else {
                          setSelectedSkills([]);
                        }
                      }}
                      required
                    />
                    {errorMsg && (
                      <div className="text-danger mt-2">{errorMsg}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="frm-box align-items-start">
                    <Form.Label>Areas of Interest</Form.Label>
                    <Select
                      isMulti
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      placeholder="Select areas of interest"
                      options={interestsList}
                      value={selectedIntrest.map((skill) => ({
                        value: skill.id,
                        label: skill.name,
                      }))}
                      isLoading={isLoading}
                      onChange={(e) => {
                        console.log(e);
                        if (!_.isEmpty(e)) {
                          let data = [];
                          console.log("check---", e);
                          for (let skill of interestSet) {
                            for (let sO of e) {
                              if (
                                _.toNumber(sO.value) === _.toNumber(skill.id)
                              ) {
                                data.push(skill);
                              }
                            }
                          }
                          console.log("set data", data);
                          setselectedIntrest(data);
                        } else {
                          setselectedIntrest([]);
                        }
                      }}
                    />
                  </Form.Group>

                  {/* Selected interests chips */}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="frm-box">
                    <Form.Label>Total Experience</Form.Label>
                    <Form.Select
                      onChange={(ev) => {
                        setSelectedExperience(ev.target.value);
                      }}
                      value={selectedExperience}
                    >
                      <option value="">Select Experience</option>
                      {experience.map((ex, index) => {
                        return (
                          <option
                            value={ex?.value}
                            selected={
                              selectedExperience === ex?.value ? true : false
                            }
                            key={index}
                          >
                            {ex?.value}
                          </option>
                        );
                      })}
                      {/* Add options here */}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="frm-box">
                    <Form.Label>Designation</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter designation"
                      value={dsgn}
                      onChange={(e) => setDsgn(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="frm-box">
                    <Form.Label>Linkedin Profile URL</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Paste url"
                      value={linkedInURL}
                      onChange={(e) => setLinkedInURL(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="frm-box">
                    <Form.Label>Twitter Profile URL</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Paste url"
                      value={twitterURL}
                      onChange={(e) => setTwitterURL(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {false && (
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="frm-box">
                      <Form.Label>Price</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter price in $"
                        onChange={(e) => setPrice(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <div className="d-flex justify-content-end gap-3 btn-footer">
                <button
                  className="btn-primary"
                  onClick={() => navigate("/learn/coaching-services")}
                >
                  Cancel
                </button>

                <button
                  className="btn-primary active-page"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </section>

        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={true}
          isConfirmwithNo={true}
          confirmId={selectedSkills}
          confirmAction={() => navigate("/learn/coaching-services")}
          isRightIcon={true}
        />
      </Page>
    </>
  );
};

export default RegisterCoachForm;
